import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      badge: 'Enterprise',
      title: 'Employee Commute Solutions',
      description: 'Automated route planning and shared mobility clusters to reduce your carbon footprint and operational costs.',
      image: '/service_employee_commute.png',
      linkText: 'Learn More',
      badgeClass: 'bg-primary-container text-on-primary-container'
    },
    {
      badge: 'Premium',
      title: 'On-Demand Executive Travel',
      description: "Lounge-standard comfort with dedicated chauffeurs available at a moment's notice for your VIPs.",
      image: '/service_executive_travel.png',
      linkText: 'View Fleet',
      badgeClass: 'bg-secondary-container text-on-secondary-container'
    },
    {
      badge: 'Flexible',
      title: 'Long-term Corporate Rentals',
      description: 'Subscription-based mobility assets for project-based teams and outstation business travellers.',
      image: '/service_corporate_rentals.png',
      linkText: 'Request Quote',
      badgeClass: 'bg-surface-container-highest text-on-surface'
    }
  ];

  return (
    <section className="py-[40px] bg-surface-container-low" id="services">
      <div className="max-w-[1400px] mx-auto px-[32px]">
        <div className="text-center mb-[40px]">
          <h2 className="font-headline text-[36px] font-extrabold tracking-tight text-on-surface">Corporate Mobility Solutions</h2>
          <div className="w-[80px] h-[6px] bg-primary mx-auto mt-[16px]"></div>
        </div>
        <div className="grid md:grid-cols-3 gap-[32px]">
          {services.map((service, index) => (
            <div key={index} className="group bg-surface-container-lowest rounded-[16px] overflow-hidden hover:shadow-2xl transition-all duration-500 flex flex-col h-full border border-outline-variant/10">
              <div className="h-[256px] overflow-hidden relative">
                <img
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  src={service.image}
                />
                <div className="absolute top-[16px] left-[16px]">
                  <span className={`${service.badgeClass} px-[12px] py-[4px] text-[12px] font-bold rounded-full uppercase tracking-widest`}>
                    {service.badge}
                  </span>
                </div>
              </div>
              <div className="p-[32px] flex-grow flex flex-col">
                <h3 className="font-headline text-[20px] font-bold mb-[16px]">{service.title}</h3>
                <p className="text-on-surface-variant text-[14px] leading-relaxed mb-[24px]">{service.description}</p>
                <div className="mt-auto flex justify-start">
                  <a href="#contact" className="fancy-dark scale-75 origin-left">
                    <span className="top-key"></span>
                    <span className="bottom-key-1"></span>
                    <span className="bottom-key-2"></span>
                    <span className="text">{service.linkText}</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;


